import * as React from 'react';
import {Category} from '../data';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';

interface SidebarProps {
    categories: Category[];
    activeCategory?: Category;
    onCategorySelect?: (category: Category) => any;
}

export const computeSidebarWidth = () => {
    return 234;
};

export class Sidebar extends React.Component<SidebarProps, {}> {
    render() {
        return (
            <div className="sidebar" style={this.getRootStyle()}>
                <List style={this.getListStyle()}>
                {this.props.categories.map(category => this.renderCategory(category))}
                </List>
            </div>
        );
    }

    private renderCategory(category: Category) {
        return (
            <ListItem
                data-test-id={`menu-category-${category.id}`}
                key={category.id}
                primaryText={category.label}
                style={this.getItemStyle(category)}
                onClick={() => this.onItemClick(category)}
            ></ListItem>
        );
    }

    private onItemClick(category: Category) {
        this.props.onCategorySelect(category);
    }

    private getRootStyle() {
        return {
            width: computeSidebarWidth() + "px",
            backgroundColor: "#ECEBEB"
        };
    }

    private getListStyle() {
        return {
            backgroundColor: 'transparent',
            paddingTop: 0,
            paddingBottom: 0
        };
    }

    private getItemStyle(category: Category) {
        let activeStyles = {
            color: "#16191d",
            backgroundColor: "#ced0d6"
        };

        let style = {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "14px",
            color: 'rgba(61, 73, 89, 1)'
        };

        if (category === this.props.activeCategory) {
            Object.assign(style, activeStyles);
        }

        return style;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/components/Sidebar.tsx
 **/